import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ReactComponent as CheckIcon } from '../../../../assets/icons/check_purple_icon.svg';
import {
  navigateToView,
  navigateToViewOnly,
  fetchById,
} from 'store/appTrack/actions';
import { useNavigate } from 'react-router-dom';
import { claimActive, updateFormField } from 'store/forms/actions';
import { isBeneficiary, isCoe } from 'utils';

const ActionList = props => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(state => state.user);
  const cancel = useSelector(state => state.appTrack.permissions.cancel);
  const edit =
    isBeneficiary(user.groups) && props.activeTaskId === 'submit_application';
  const beneficiary = isBeneficiary(user.groups);
  const coe = isCoe(user.groups);
  const scrollToTop = () => {
    document.body.scrollTop = 0; // for Safari
    document.documentElement.scrollTop = 0; // for Chrome, Firefox, IE and Opera
  };

  const taskId = props.id;

  const onView = value => {
    props.open(false);
    scrollToTop();
    navigate(`/viewForm/${taskId}`);
  };

  const onCoeView = value => {
    props.open(false);
    scrollToTop();
    navigateToViewOnly(navigate, props.id);
  };

  const onCoeEdit = value => {
    props.open(false);
    scrollToTop();
    navigateToView(navigate, props.id);
  };

  const onEdit = value => {
    scrollToTop();
    dispatch(
      updateFormField({
        group: 'task',
        key: 'processInstanceId',
        value: props.id,
      })
    );
    dispatch(
      updateFormField({
        group: 'carrier',
        key: 'viewMode',
        value: false,
      })
    );
    dispatch(claimActive(navigate, props.id));
  };

  const onCancel = () => {
    props.open(false);
    scrollToTop();
    props.setCancelModal(true);
  };

  return (
    <div id={`action-list-for-${props.id}`} className="popover-container">
      {true ? (
        <div
          id="action-button-view"
          className="popover-item"
          onClick={() => (coe ? onCoeView(props.id) : onView(props.id))}
        >
          Προβολή <CheckIcon className="check" />
        </div>
      ) : null}
      {/* { edit ? <div id="action-button-edit" className="popover-item" onClick={()=> coe ? onCoeEdit(props.id) : onEdit(props.id)}>Επεξεργασία <CheckIcon className="check"/></div> : null } */}
      {cancel ? (
        <div
          id="action-button-cancel"
          className="popover-item"
          onClick={() => onCancel(props.id)}
        >
          Ακύρωση <CheckIcon className="check" />
        </div>
      ) : null}
    </div>
  );
};

export default ActionList;
